import React from "react";
import { useSelector } from "react-redux";
import PrimaryButton from "../../../../../shared/components/ui/btns/primaryBtn/PrimaryButton";
import { formatSaveDate } from "../../../../../shared/utils/utils";
import classes from "./SaveButton.module.css";

const SaveButton = ({ onClick, disabled, date, className }) => {
    const { texts } = useSelector((state) => state.translate);
    const lastSavedAt = formatSaveDate(date);


    return (
        <div className={`${classes.SaveRow}${className ? ` ${className}` : ""}`}>
            {lastSavedAt && (
                <span className={classes.SaveSuccess}>
                    {texts.publishedSuccessfully}{lastSavedAt}
                </span>
            )}
            <PrimaryButton
                onClick={onClick}
                disabled={disabled}
                btnText={texts.saveChanges}
                dropClass={classes.PublishBtn}
            />

        </div>
    );
};

export default SaveButton;
